import React from "react";

const Map = () => {
  return (
    <div>
      <iframe
        src='https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3037.8401310671966!2d49.85853047567591!3d40.41239225590389!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sAhm%C9%99d%20Rajabli%203%2F3A.%20AZ1052%20Baku%2C%20Azerbaijan.!5e0!3m2!1sru!2skg!4v1710403109642!5m2!1sru!2skg'
        width='100%'
        height='400'
        style={{ border: "5px solid white", margin: 0 }}
        allowFullScreen=''
        loading='lazy'
        referrerPolicy='no-referrer-when-downgrade'
      ></iframe>
    </div>
  );
};

export default Map;
